import { initializeApp } from "firebase/app";
import { getFunctions } from "firebase/functions";
import { getAnalytics } from "firebase/analytics";
import { initializeFirestore } from "firebase/firestore";

var firebaseConfig = {}
let environment = 'development'

if (window.location.hostname == process.env.VUE_APP_PRODUCTION_HOSTNAME) {
  firebaseConfig = {
    apiKey: "AIzaSyA-UWd0Fisl0rDrfTpnJNBo488v7j3zVDE",
    authDomain: "ideaverse-production.firebaseapp.com",
    projectId: "ideaverse-production",
    storageBucket: "ideaverse-production.firebasestorage.app",
    messagingSenderId: "1062755459893",
    appId: "1:1062755459893:web:9d78d3dc89a31fbbc4627c",
    measurementId: "G-9S9LDTG636"
  };
  console.log('Production config loaded');
  environment = 'production';
} else {
  firebaseConfig = {
    apiKey: "AIzaSyDkyWdG8iHzUSUrfgPnEzcb4hgsf55CeRA",
    authDomain: "ideaverse-development.firebaseapp.com",
    projectId: "ideaverse-development",
    storageBucket: "ideaverse-development.firebasestorage.app",
    messagingSenderId: "918695363398",
    appId: "1:918695363398:web:7be3483eb0ec7569789b47"
  };
  console.log('Development config loaded');
}

const app = initializeApp(firebaseConfig);
const functions = getFunctions(app);
const analytics = getAnalytics(app);

// Initialize Firestore for the non-default database 'ideabase' with networking fallbacks
const db = initializeFirestore(app, {
  experimentalAutoDetectLongPolling: true,
  useFetchStreams: false
}, 'ideabase');

console.log('Firestore initialized for databaseId "ideabase" with long-polling fallback.');

export { app, functions, analytics, environment, db };